export default __webpack_public_path__ + "static/branca-afa31e8f633578e3a7c8ff5e52488232.jpg";